import * as React from "react";
import DiscussionModel from "../models/DiscussionModel";
import SortComponent from "./SortComponent";
import CommentList from "./CommentList";
import "./Container.styl";
import ButtonShow from "./ButtonShow";
import ButtonHide from "./ButtonHide";
import Form from "./Form";
import ModalLogin from "./ModalLogin";
import ModalDelete from "./ModalDelete";
import ModalError from "./ModalError";
import ModalReport from "./ModalReport";
import ModalReportResult from "./ModalReportResult";
import ModalBlock from "./ModalBlock";
import ButtonAdd from "./ButtonAdd";
import ModalPremium from "./ModalPremium";
import ModalVerify from "./ModalVerify";

export default class Container extends React.Component<{
    model: DiscussionModel,
}> {

    private content: React.RefObject<HTMLDivElement>;
    private timer: number = 0;

    public constructor(props) {
        super(props);
        this.content = React.createRef();
    }

    public render(): React.ReactNode {
        const model = this.props.model;
        return (
            <div className="Discussion-Container-Root">
                <div className="Discussion-Container-Button">
                    {this.renderButton()}
                </div>
                <div className="Discussion-Container-Content" ref={this.content}>
                    {this.renderForm()}
                    {this.renderSort()}
                    {this.renderContent()}
                    {this.renderLoading()}
                    {this.renderAdd()}
                </div>
                {this.renderModals()}
            </div>
        );
    }

    public componentDidUpdate(props: { model: DiscussionModel }): void {

        const content = this.content.current;
        const model = this.props.model;

        if (props.model.getDisplay() != model.getDisplay()) {

            if (this.timer) {
                window.clearTimeout(this.timer);
            }

            if (model.getDisplay()) {

                if (!this.timer) {
                    content.style.overflow = "hidden";
                    content.style.height = "0";
                    content.style.display = "block";
                }

                content.style.transition = "height .5s ease-in";

                this.timer = window.setTimeout(() => {
                    content.style.height = content.scrollHeight + "px";
                    this.timer = window.setTimeout(() => {
                        content.style.overflow = "none";
                        content.style.height = "auto";
                        content.style.transition = "";
                        this.timer = 0;
                    }, 500);
                }, 0);

            } else {

                if (!this.timer) {
                    content.style.overflow = "hidden";
                    content.style.height = content.scrollHeight + "px";
                }

                content.style.transition = "height .5s ease-out";

                this.timer = window.setTimeout(() => {
                    content.style.height = "0";
                    this.timer = window.setTimeout(() => {
                        content.style.transition = "";
                        content.style.display = "none";
                        this.timer = 0;
                    }, 500);
                }, 0);

            }
        }

    }

    private renderAdd(): React.ReactNode {
        const model = this.props.model;
        if (!model.getComments().isEmpty()) {
            return (
                <ButtonAdd/>
            );
        } else {
            return null;
        }
    }

    private renderLoading(): React.ReactNode {
        if (this.props.model.isLoading()) {
            return (
                <div className="Discussion-Container-Loading"/>
            );
        } else {
            return null;
        }
    }

    private renderForm(): React.ReactNode {
        return (
            <Form model={this.props.model}/>
        );
    }

    private renderContent(): React.ReactNode {
        const model = this.props.model;
        if (!model.getComments().isEmpty()) {
            return (
                <CommentList model={model}/>
            );
        } else {
            return null;
        }
    }

    private renderSort(): React.ReactNode {
        const model = this.props.model;
        if (model.getTotal() > 0) {
            return (
                <SortComponent current={model.getSort()}/>
            );
        } else {
            return null;
        }
    }

    private renderButton(): React.ReactNode {
        const model = this.props.model;
        if (model.getDisplay()) {
            return (
                <ButtonHide total={model.getTotal()}/>
            );
        } else {
            return (
                <ButtonShow total={model.getTotal()}/>
            );
        }
    }

    private renderModals(): React.ReactNode {
        const model = this.props.model;
        if (model.getBlockModal()) {
            return <ModalBlock/>;
        } else if (model.getDeleteModal()) {
            return <ModalDelete/>;
        } else if (model.getReportModal()) {
            return <ModalReport/>;
        } else if (model.getReportResultModal()) {
            return <ModalReportResult/>;
        } else if (model.getModalLogin()) {
            return <ModalLogin type={model.getModalLoginType()}/>
        } else if (model.getModalPremium()) {
            return <ModalPremium/>;
        } else if (model.getModalVerify()) {
            return <ModalVerify/>;
        } else if (model.getModalError()) {
            return <ModalError type={model.getModalErrorType()}/>;
        } else {
            return null;
        }
    }

}